document.addEventListener("click", function (e) {
  const tab = e.target.closest(".gender-tab");
  if (!tab) return;

  // Wait for Broadcast AJAX filtering to finish
  setTimeout(() => {
    document.querySelectorAll(".gender-tab").forEach((btn) => {
      btn.classList.remove("is-active");
    });

    tab.classList.add("is-active");
  }, 50);
});
